<template>
	<div>
		<div>
			<el-select
			:value="curVipId"
			@change="change"
			style="width:100%"
			filterable
			remote
			:disabled="disabled"
			reserve-keyword
			placeholder="请输入顾客名称或手机号"
			:remote-method="remoteMethod">
				<el-option
				v-for="(item) in vipList" :key="item._id"
				:label="(
				!item.club_card||item.club_card. surplus_day==0?
				'':
				'['+item.club_card. surplus_day+'星]'
				)+
				item.basic_info.nick_name+
				(item.club_card. surplus_day===3&&item.club_card.old_interest===true?' (老)':'')+
				' ('+item.basic_info.user_mobile+')'"
				:value="item._id">
				</el-option>
				<template slot="empty">
					<div style="width:300px;font-size: 14px;color:red;text-align: center;padding:10px 0;">没有客户信息，请创建客户档案</div>
				</template>
			</el-select>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				vipList:[],
				curVipId:'',
			}
		},
		props:{
			propsVipInfo:{
				default:()=>{
					return {}
				}
			},
			disabled:{
				default:false
			}
		},
		watch:{
			propsVipInfo(n){
				if(n===''){
					this.vipList=[];
					this.curVipId=''
				}else{
					if(n.member_id){
						if(n.member_id!==this.curVipId){
							this.curVipId = n.member_id;
							this.vipList = [
								{
									_id:n.member_id,
									basic_info:{
										user_mobile:n.member_mobile,
										nick_name:n.member_name,
									},
									card_info:{
										user_yue:n.member_yue,
										user_zenge:n.member_zenge,
									},
									pets_info:[
										{
											_id:n.pet_id,
											apply_type:n.apply_type,
											category_info:n.category_info,
											// class_name:n.pet_class,
											// class_type:n.pet_class_type,
											nick_name:n.pet_name,
											// type_name:n.pet_type,
											bron_date:n.pet_birthday,
											sex:n.pet_sex,
											sterilization:n.pet_sterilization,
											status:{title: "正常", value: "1"},
										}
									],
									club_card:{
										grades:n.member_type,
									}
								}
							];
							this.change(this.curVipId)
						}
					}else{
						this.vipList=[];
						this.curVipId=''
					}
				}
			}
		},
		computed:{
			curVip(){
				return this.vipList.filter(item=>{return item._id==this.curVipId});
			},
		},
		mounted(){
		},
		methods: {
			change(id){
				this.curVipId = id
				if(this.curVip[0]){
					this.$emit("getCurVipItem",this.curVip[0])
				}else{
					this.$emit("getCurVipItem",'')
				}
			},
			// 下拉改变
			// @visible-change="visibleChange"
			// visibleChange(a) {
			// 	if (a) {
			// 		this.remoteMethod('');
			// 	}
			// },
			remoteMethod(str){
				this.$util.getVipList(str).then(list=>{
					this.vipList = list
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	
</style>
